// Couleur stable par agence : identique pour tous les utilisateurs (admin, associé, mécano)
export const AGENCY_COLORS = [
  { bg: 'rgba(254, 237, 0, 0.25)', border: '#FEED00', text: '#FEED00', name: 'Jaune' },
  { bg: 'rgba(59, 130, 246, 0.25)', border: '#3B82F6', text: '#60A5FA', name: 'Bleu' },
  { bg: 'rgba(168, 85, 247, 0.25)', border: '#A855F7', text: '#C084FC', name: 'Violet' },
  { bg: 'rgba(34, 197, 94, 0.25)', border: '#22C55E', text: '#4ADE80', name: 'Vert' },
  { bg: 'rgba(249, 115, 22, 0.25)', border: '#F97316', text: '#FB923C', name: 'Orange' },
  { bg: 'rgba(236, 72, 153, 0.25)', border: '#EC4899', text: '#F472B6', name: 'Rose' },
  { bg: 'rgba(20, 184, 166, 0.25)', border: '#14B8A6', text: '#2DD4BF', name: 'Turquoise' },
  { bg: 'rgba(239, 68, 68, 0.25)', border: '#EF4444', text: '#FCA5A5', name: 'Rouge' },
];

const CITY_COLOR_INDEX = {
  beziers: 0,
  perpignan: 1,
  montpellier: 2,
  marseille: 3,
};

const normalize = (s = "") =>
  s.toString().trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const hashIndex = (str = "") => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return 4 + (h % (AGENCY_COLORS.length - 4));
};

export const getAgencyColorByAgency = (agency) => {
  if (!agency) return AGENCY_COLORS[0];
  const idx = CITY_COLOR_INDEX[normalize(agency.city)];
  if (idx !== undefined) return AGENCY_COLORS[idx];
  return AGENCY_COLORS[hashIndex(agency.id)];
};

export const makeAgencyColorGetter = (agencies) => (agencyId) =>
  getAgencyColorByAgency(agencies.find((a) => a.id === agencyId));

export const AgencyDot = ({ color, className = "" }) => (
  <span
    className={`inline-block w-2.5 h-2.5 rounded-full border-2 shrink-0 ${className}`}
    style={{ backgroundColor: color.bg, borderColor: color.border }}
  />
);
